@import '../../../../../../../../static/less/variables';

.assign-new-user,
.assign-exists-user {
  border-bottom: 1px solid @pipl-light-border;
}

.assign-new-user {
  margin-bottom: 20px;
  padding: 13px 0 20px;

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: @input-border;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: @input-border;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: @input-border;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: @input-border;
  }
}

.assign-null-user {
  margin-top: 20px;
  .c-radio-blue-button {
    margin-bottom: 0;
  }
}

.c-modal-subtext {
  font-weight: 600;
}

.bootstrap-typeahead-menu {
  max-width: 100%;
}

.assign-exists-user {
  padding-bottom: 35px;
  .bootstrap-typeahead-input {
    input {
      height: 36px;
    }
  }
  .bootstrap-typeahead {
    margin-top: 8px;
  }
}

.input-group-addon {
  color: @pipl-modal-subtext;
}

.c-signup-form {
  margin-top: 8px;
  .help-block {
    margin-top: 3px;
    margin-bottom: 0;
    font-size: 12px;
    text-align: center;
  }

  .c-signup__submit {
    display: table-cell;
    text-align: center;
  }
  .form-buttons {
    margin-top: 24px;
    display: table;
  }
  .c-signup__login {
    width: 100%;
    font-size: 14px;
    display: table-cell;
    vertical-align: middle;
    text-align: right;
    padding-right: 0;
  }
  .form-control {
    border-radius: 3px;
    box-shadow: none;
    font-size: 15px;
    height: 36px;
  }
  .input-group-addon {
    min-width: 161px;
    text-align: left;
    font-size: 15px;
    font-weight: 600;
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/ManagementPanel/routes/Subscriptions/components/Modals/ModalAssignSubscription.less